import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaskitoDirective, MaskitoPattern } from '@maskito/angular';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { environment } from '@wz-environments';
import { TunnelSanteFormsModule } from '@wz-forms';
import { TunnelSanteI18nModule } from '@wz-i18n';
import { TunnelSanteIconModule } from '@wz-icon';
import { TunnelSanteLayoutModule } from '@wz-layout';
import { HeaderAfiComponent } from '@wz-tunnelsante/components/header-afi/header-afi.component';
import { ToastComponent } from '@wz-tunnelsante/components/toaster/toast.component';
import { TunnelAuthorizationGuard } from '@wz-tunnelsante/guards/tunnel-authorization.guard';
import { TunnelSanteUiModule } from '@wz-ui';
import { CookieModule } from 'ngx-cookie';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SouscriptionContratFormuleComponent } from './components/Souscriptions/souscription-contrat-formule/souscription-contrat-formule.component';
import { SouscriptionCoordonneesComponent } from './components/Souscriptions/souscription-coordonnees/souscription-coordonnees.component';
import { BulletinAdhesionDialogComponent } from './components/Souscriptions/souscription-recap-signature/modals/bulletin-adhesion-dialog/bulletin-adhesion-dialog.component';
import { SouscriptionRecapSignatureComponent } from './components/Souscriptions/souscription-recap-signature/souscription-recap-signature.component';
import { SouscriptionSignatureComponent } from './components/Souscriptions/souscription-signature/souscription-signature.component';
import { FooterDemandeDevisComponent } from './components/footer-demande-devis/footer-demande-devis.component';
import { FooterComponent } from './components/footer/footer.component';
import { FilePathManagerComponent } from './components/insurances/file-manager/file-manager.component';
import { DemanderDevisDialogComponent } from './components/insurances/formula-pickerB2C/demander-devis-dialog/demander-devis-dialog.component';
import { EtreRappeleDialogComponent } from './components/insurances/formula-pickerB2C/etre-rappele-dialog/etre-rappele-dialog.component';
import { PictoInfosComponent } from './components/insurances/formula-pickerB2C/picto/picto-nouveaute/picto-infos.component';
import { InfobulleDetailsGarantiesComponent } from './components/insurances/health-assure-formB2C/infobulle/infobulle-details-garanties/infobulle-details-garanties.component';
import { MentionsLegalesEtCguComponent } from './components/mentions-legales-et-cgu/mentions-legales-et-cgu.component';
import { ClientComponent } from './components/nps/client/client.component';
import { OpinionAComponent } from './components/nps/opinion-a/opinion-a.component';
import { OupsComponent } from './components/nps/oups/oups.component';
import { ProspectComponent } from './components/nps/prospect/prospect.component';
import { RemerciementComponent } from './components/nps/remerciement/remerciement.component';
import { ScoringComponent } from './components/nps/scoring/scoring.component';
import { ReclamationsComponent } from './components/reclamations/reclamations.component';
import {
  wzCoreExportedComponents,
  wzCoreExportedDirectives,
  wzCoreExportedPipes,
} from './wz-core/wz-core-exports';
import { wzCoreExportedMatModules } from './wz-core/wz-core-material-exports';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ...wzCoreExportedMatModules,
    TunnelSanteIconModule,
    TunnelSanteI18nModule,
    TunnelSanteLayoutModule,
    TunnelSanteUiModule,
    TunnelSanteFormsModule,
    NgxMaskDirective,
    FormlyMaterialModule,
    FormlyModule,
    SlickCarouselModule,
    CookieModule.withOptions({
      path: '/', // default path
      sameSite: 'lax', // recommended default
      secure: environment.name == 'production',
    }),
    MaskitoDirective,
    MaskitoPattern,
    PictoInfosComponent,
  ],
  declarations: [
    SouscriptionCoordonneesComponent,
    SouscriptionRecapSignatureComponent,
    SouscriptionContratFormuleComponent,
    BulletinAdhesionDialogComponent,
    OupsComponent,
    //ContentLoaderComponent,
    HeaderAfiComponent,
    FilePathManagerComponent,
    ReclamationsComponent,
    MentionsLegalesEtCguComponent,
    OpinionAComponent,
    RemerciementComponent,
    ClientComponent,
    ProspectComponent,
    ScoringComponent,

    FooterComponent,
    FooterDemandeDevisComponent,
    ToastComponent,

    SouscriptionSignatureComponent,
    ...wzCoreExportedComponents,
    ...wzCoreExportedPipes,
    ...wzCoreExportedDirectives,
    DemanderDevisDialogComponent,
    EtreRappeleDialogComponent,
    InfobulleDetailsGarantiesComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    ...wzCoreExportedMatModules,
    TunnelSanteLayoutModule,
    TunnelSanteUiModule,
    TunnelSanteIconModule,
    TunnelSanteI18nModule,
    TunnelSanteFormsModule,

    SouscriptionCoordonneesComponent,
    SouscriptionRecapSignatureComponent,
    SouscriptionContratFormuleComponent,
    BulletinAdhesionDialogComponent,
    OupsComponent,
    HeaderAfiComponent,
    ToastComponent,
    FilePathManagerComponent,
    ReclamationsComponent,
    MentionsLegalesEtCguComponent,
    OpinionAComponent,
    RemerciementComponent,
    ClientComponent,
    ProspectComponent,
    ScoringComponent,

    FooterComponent,
    FooterDemandeDevisComponent,

    ...wzCoreExportedComponents,
    ...wzCoreExportedPipes,
    ...wzCoreExportedDirectives,
    MaskitoDirective,
    MaskitoPattern,
  ],
  providers: [provideNgxMask(), TunnelAuthorizationGuard],
})
export class TunnelSanteCoreModule {}
